var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('PagedDataTable',{attrs:{"i18nGroup":"directNavigationItem","form-route":"directNavigationForm","headers":_vm.headers,"repository":_vm.directNavigationItemRepository}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }